import { AtomEffect, DefaultValue } from 'recoil';
import { AppCacheStorageType } from '../../utils/cache/cache';
import { recoilCache } from './recoilCache';

/**
 * Caches an atom to some persistance layer. The atom will be initialized from the store and kept in
 * sync so cached values can be restored on page refresh.
 */
export const cacheAtomEffect =
  <TValue>(storageType: AppCacheStorageType, ttl?: number | Duration): AtomEffect<TValue> =>
  ({ onSet, setSelf, trigger, node }) => {
    if (trigger === 'get') {
      const cacheValue = recoilCache[storageType].get<TValue>(node.key);
      if (cacheValue !== undefined) setSelf(cacheValue);
    }
    onSet(newValue => {
      if (newValue instanceof DefaultValue) return;
      recoilCache[storageType].set(node.key, newValue, ttl);
    });
  };
